module.exports = __webpack_public_path__ + "static/media/delivery.3f8279b2.png";